export const buildTableState = (fullList, pager) => {
  const { page, limit } = pager;
  const offset = (page - 1) * limit;
  return {
    data: fullList.slice(offset, offset + limit),
    count: fullList.length,
    limit,
    page,
    isLoading: false,
  };
};

export const inactiveRowCount = (list) =>
  list.filter((row) => row.isActive === false).length;
